import Pro1 from "../assests/pro1.webp";
import Pro2 from "../assests/pro2.webp";
import Pro3 from "../assests/pro3.webp";
import Pro4 from "../assests/pro4.webp";

import Face1 from "../assests/faceimg.webp";
import Face2 from "../assests/faceimg2.webp";
import Face3 from "../assests/faceimg.webp";
import Face4 from "../assests/faceimg2.webp";

const products = [
  {
    id:1,
    name:"Glow Essence Serum",
    category:"Celiora Collection",
    desc:"Deep hydration with Korean skincare technology.",
    product:Pro1,
    face:Face1,
    badge:"Best Seller"
  },
  {
    id:2,
    name:"Hydra Moisturizer",
    category:"Celiora Collection",
    desc:"Locks moisture for soft glowing skin.",
    product:Pro2,
    face:Face2,
    badge:"New"
  },
  {
    id:3,
    name:"Radiance Cleanser",
    category:"Celiora Collection",
    desc:"Gentle cleanser for healthy glowing skin.",
    product:Pro3,
    face:Face3,
    badge:"Popular"
  },
  {
    id:4,
    name:"Daily Sunscreen",
    category:"Celiora Collection",
    desc:"SPF protection with lightweight finish.",
    product:Pro4,
    face:Face4,
    badge:"SPF 50+"
  }
];

export default function AboutCeliora(){

return(

<section className="bg-[#F7F4EF] py-28 -mt-20">

<div className="max-w-[1650px] mx-auto px-8">

<div className="text-center max-w-3xl mx-auto">

<span className="uppercase tracking-[5px] text-sm text-[#726A63]">

ABOUT CELIORA

</span>

<h2 className="font-heading text-6xl mt-5 leading-tight">

Seoul Inspired.

<br/>

Crafted For Indian Skin.

</h2>

<p className="mt-8 text-[#5E5753] leading-8 text-lg">

Every Celiora formula combines Korean innovation with
ingredients carefully selected for Indian skin.

</p>

</div>

<div className="grid xl:grid-cols-4 md:grid-cols-2 grid-cols-1 gap-8 mt-24">

{products.map((item)=>(

<div key={item.id} className=" group relative aspect-square overflow-hidden bg-white shadow-[0_20px_60px_rgba(0,0,0,.08)] transition-all duration-700 hover:-translate-y-3 
hover:shadow-[0_30px_80px_rgba(0,0,0,.15)] ">

<img src={item.face} alt="" className=" absolute inset-0 w-full h-full object-cover transition-all duration-700 group-hover:opacity-0 group-hover:scale-110" />
<img src={item.product} alt="" className=" absolute inset-0 w-full h-full object-cover opacity-0 transition-all duration-700 group-hover:opacity-100 group-hover:scale-100"/>

{/* Overlay (Default) */}

<div
  className="
  absolute
  inset-0
  bg-gradient-to-t
  from-black/75
  via-black/20
  to-transparent
  transition-all
  duration-500
  group-hover:opacity-0
  "
/>

{/* Badge */}

<div
  className="
  absolute
  top-5
  left-5
  z-30
  bg-white/90
  backdrop-blur-md
  px-4
  py-2
  text-[11px]
  uppercase
  tracking-[3px]
  font-semibold
  text-[#1F1B18]
  transition-all
  duration-500
  group-hover:opacity-0
  "
>

  {item.badge}

</div>

{/* Default Content */}

<div
  className="
  absolute
  bottom-0
  left-0
  right-0
  z-30
  p-7
  transition-all
  duration-500
  group-hover:opacity-0
  group-hover:translate-y-10
  "
>

  <span
    className="
    uppercase
    tracking-[4px]
    text-xs
    text-white/70
    "
  >

    {item.category}

  </span>

  <h3
    className="
    text-white
    text-3xl
    font-heading
    mt-3
    "
  >

    {item.name}

  </h3>

  <p
    className="
    text-white/90
    mt-4
    leading-7
    "
  >

    {item.desc}

  </p>

  <button
    className="
    mt-7
    bg-white
    text-[#1F1B18]
    px-7
    py-3
    font-semibold
    transition-all
    duration-500
    hover:bg-[#1F1B18]
    hover:text-white
    "
  >

    Buy Now →

  </button>

</div>

</div>

))}

</div>

</div>

</section>

);

}

